export const setSearchParams = (
  newParams: Record<string, string | number | boolean | null | undefined>
): void => {
  const url = new URL(window.location.href);

  Object.entries(newParams).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, String(value));
    }
  });

  window.history.pushState({}, '', url.toString());
};
